module.exports = __webpack_public_path__ + "img/PT25.12707592.png";